import React from "react";
import { AcademicCapIcon } from "@heroicons/react/solid";

export default function Projects() {
    return (
      <div
          id="projects"
          //mt: margin top; mx: horizontal margin (mx-size)
          className="mx-12 mt-60 lg:mx-60 items-center justify-center text-justify"
        >
          <div>
            <div className="table">
              <AcademicCapIcon className="h-5 w-5 mr-4 text-yellow_vs" />{" "}
              <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
                Projects
              </code>
              <div className="table-cell border-b border-b-[#e6f1ff] border-opacity-25 w-full"></div>
            </div>

            <div className="text-[#a2aabc] text-lg mt-5">
              <p>Let's check out some of my projects!</p>
              <br/>

              <code style = {{fontfamily: 'Courier New'}}>
                <div>
                  <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
                    RTSL - Real-Time Sign Language Translator
                  </code>
                  <code style = {{fontfamily: 'Courier New', fontStyle: 'italic'}}>
                    Python, PyTorch, Vue, Mediapipe, Numpy, Hugging Face
                  </code>
                  <p>
                    • A real-time ASL translation pipeline that recognizes continuous signing from live video and converts it into
                    structured gloss sequences using a Temporal Graph Convolutional Network (TGCN) with sliding-window
                    inference for temporal modeling of hand and body landmarks.
                  </p>
                  <p>
                    • Used Glossa-BART transformer for sequence-to-sequence translation of ASL glosses to natural English text,
                    achieving 87% semantic similarity with custom conversational ASL glosses.
                  </p>
                  <p>
                    • Developed a browser extension for Zoom/Google Meet/Microsoft Teams that provides real-time ASL-to-English
                    translation, enabling accessibility for deaf and hard-of-hearing participants in online meetings through live
                    captioning of signed content.
                  </p>

                  <br/> <br/>

                  <div>
                    <a href="https://github.com/PourquoiEstTu/rtsl">
                      <button
                        className="border border-lightblue_vs text-lightblue_vs  p-1.5 rounded hover:bg-opacity-10 hover:bg-lightblue_vs "
                        >
                          Visit github repo here! &nbsp;
                          <i className='pi  pi-check'> </i>
                      </button>
                    </a>
                  </div>

                </div>

                <br/> <br/> <br/>

                <div>
                  <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
                    snoop.ai
                  </code>
                  <code style = {{fontfamily: 'Courier New', fontStyle: 'italic'}}>
                    Next.js, React, FastAPI, SQLite, C++, Groq AI
                  </code>
                  <p>
                    • Track winner at MakersLounge Innovation Hackathon Toronto — an AI-powered competitor monitoring dashboard
                    that watches Bluesky for keyword matches, analyzes posts with AI, and surfaces prioritized market events.
                  </p>
                  <p>
                    • Built a C++ scraper pipeline connected to Bluesky Jetstream, a FastAPI backend with Groq AI analysis,
                    and a Next.js dashboard for profiles, sort/filter/search, and actionable business insights.
                  </p>

                  <br/> <br/>

                  <div>
                    <a target='_blank' rel="noreferrer" href="https://github.com/HaNguyenCS/snoop.ai">
                      <button
                        className="border border-lightblue_vs text-lightblue_vs  p-1.5 rounded hover:bg-opacity-10 hover:bg-lightblue_vs "
                        >
                          Visit github repo here! &nbsp;
                          <i className='pi  pi-check'> </i>
                      </button>
                    </a>
                  </div>

                </div>

                <br/> <br/> <br/>

                <div>
                  <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
                    NailedIt.ai
                  </code>
                  <code style = {{fontfamily: 'Courier New', fontStyle: 'italic'}}>
                    React, FastAPI, ElevenLabs, Twilio, Google Calendar API
                  </code>
                  <p>
                    • Track winner at Cursor Hackathon Toronto — a multilingual AI receptionist for nail salons that answers
                    customer phone calls, transcribes conversations, and books appointments using voice AI.
                  </p>
                  <p>
                    • Built a live dashboard with call status, voice wave animation, real-time transcript, and translation into
                    the salon owner’s preferred language, with confirmed bookings automatically added to Google Calendar.
                  </p>

                  <br/> <br/>

                  <div>
                    <a target='_blank' rel="noreferrer" href="https://github.com/YvesDonato/cursorhackathon/tree/main">
                      <button
                        className="border border-lightblue_vs text-lightblue_vs  p-1.5 rounded hover:bg-opacity-10 hover:bg-lightblue_vs "
                        >
                          Visit github repo here! &nbsp;
                          <i className='pi  pi-check'> </i>
                      </button>
                    </a>
                  </div>

                </div>

                <br/> <br/> <br/>

                <div>
                  <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
                    Personal Website
                  </code>
                  <code style = {{fontfamily: 'Courier New', fontStyle: 'italic'}}>
                    JavaScript, HTML, CSS, ReactJS, TailwindCSS
                  </code>

                  <br/> <br/>

                  <div>
                    <a href="/">
                      <button
                        className="border border-lightblue_vs text-lightblue_vs  p-1.5 rounded hover:bg-opacity-10 hover:bg-lightblue_vs "
                        >
                          This website! &nbsp;
                          <i className='pi  pi-check'> </i>
                      </button>
                    </a>
                  </div>

                </div>

                {/* <div>
                  <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
                    Music Center Management Website
                  </code>
                  <code style = {{fontfamily: 'Courier New', fontStyle: 'italic'}}>
                    JavaScript, HTML, CSS, ReactJS
                  </code>

                  <br/>
                  <br/>

                  <div>
                    <a target='_blank' href="http://103.130.212.35:1289/TTNhac/auth/login/">
                      <button
                        className="border border-lightblue_vs text-lightblue_vs  p-1.5 rounded hover:bg-opacity-10 hover:bg-lightblue_vs "
                        >
                          Check it out! &nbsp;
                          <i className='pi  pi-check'> </i>
                      </button>
                    </a>
                    <p>
                      username: admin | password: 123456
                    </p>
                    <br/>
                    <p>
                    • Worked as a front-end developer in a team of 5 to implement JavaScript, HTML, and CSS, using React framework
                    to create a music center website for an admin to manage up to 200 students, teachers, classrooms, and types of
                    equipment.
                    </p>
                    <code>
                    • Integrated real-time features to update class schedules, enabling admins to create classes, and manage classes’
                    status, tuition, and teachers’ salaries, resulting in a time reduction of 70% of administrative tasks.
                    </code>
                  </div>


                </div> */}
                
                <br/> <br/>

                <div>
                  <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
                    The Dill Banh Mi
                  </code>
                  <code style = {{fontfamily: 'Courier New', fontStyle: 'italic'}}>
                     ReactJS, TypeScript, AWS, Material UI, , HTML, CSS
                  </code>

                  <br/>
                  <br/>

                  <div>
                    <a target='_blank' href="https://main.d2u3drbesgrpqx.amplifyapp.com/">
                      <button
                        className="border border-lightblue_vs text-lightblue_vs  p-1.5 rounded hover:bg-opacity-10 hover:bg-lightblue_vs "
                        >
                          Check it out! &nbsp;
                          <i className='pi  pi-check'> </i>
                      </button>
                    </a>
                    <br/>
                    <p>
                    • A serverless e-commerce web app using React, hosted on AWS Amplify, enabling customers to place orders for
                    Vietnamese banh mi and drinks through a modern, responsive UI.
                    </p>
                    <code>
                    • Developed an admin dashboard with protected REST endpoints (API Gateway + Lambda + JWT authorizer) to
                    perform CRUD operations on menu sections.
                    </code>
                  </div>

                </div>

              </code>
            </div>
              
            </div>
            <br /><br />
          </div>
    );
}